var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-row", {
    staticClass: "row"
  }, [_c("a-select", {
    attrs: {
      "show-search": true,
      "not-found-content": null,
      "filter-option": true,
      placehoder: _vm.$t("com.placeInput")
    },
    on: {
      search: _vm.handleSearch,
      blur: _vm.handleBlur,
      change: _vm.handleSelectChange
    },
    model: {
      value: _vm.result,
      callback: function callback($$v) {
        _vm.result = $$v;
      },
      expression: "result"
    }
  }, _vm._l(_vm.options, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1), _c("span", {
    staticClass: "unit"
  }, [_vm._v("px")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };